import type { TrackedTranslation } from '@ps/web-core-intl';
import type { ClassNameProp, ValuesProp } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import trScreenVideo from '@swf/first/assets/video/tr-screen-video.mp4';
import trVideoMobile from '@swf/first/assets/video/tr-video-mobile.mp4';

import ProgressBar from '../ProgressBar/ProgressBar';
import Prompt from '../Prompt/Prompt';

import { progressBar } from './TransitionProgressPrompt.scss';

export type Handler = () => void;

interface TrackedText extends Partial<ValuesProp> {
  translation: TrackedTranslation;
}

interface TrackedButton extends Partial<ClassNameProp>, Partial<ValuesProp> {
  translation: TrackedTranslation;
  disabled?: boolean;
  href?: string;
}

interface Props {
  primaryButton?: TrackedButton;
  onClose?: Handler;
  onPrimaryButtonClick?: Handler;
  title: TrackedText;
  isExitPrompt?: boolean;
}

const TransitionProgressPrompt: React.FC<React.PropsWithChildren<Props>> = ({
  primaryButton,
  onPrimaryButtonClick,
  title,
  children
}) => {
  const isMobile = useSelector(select.device.isMobile);
  const video = isMobile ? trVideoMobile : trScreenVideo;

  return (
    <Prompt
      title={title}
      noCloseButton
      primaryButton={primaryButton}
      onPrimaryButtonClick={onPrimaryButtonClick}
      variant="info"
      video={video}
    >
      {children}
      <div className={progressBar}>
        <ProgressBar progressBarCompletedSteps />
      </div>
    </Prompt>
  );
};

export default TransitionProgressPrompt;
